const QUERY_TAGS = {
  FAVOURITE_SUPPLIERS: "Favourite/SUPPLIERS",
  CART: "Cart/SELF",
  PRODUCT_DETAIL: "Product/DETAIL",
  PRODUCT_OFFERS: "Product/OFFERS",
  SUPPLIER_DETAIL: "Supplier/DETAIL",
  SUPPLIER_PRODUCTS: "Supplier/PRODUCTS",
  SUPPLIER_ACCESSORIES: "Supplier/ACCESSORIES",
  SUPPLIER_RATINGS: "Supplier/RATINGS",
  MY_RATINGS: "Rating/MINE",
  PRODUCT_ACCESSORIES: "Product/ACCESSORIES",
  PRODUCT_ACCESSORY_BOUNDS: "Product/ACCESSORY_BOUNDS",
  TAXONOMY_CONTAINER_OPTIONS: "Taxonomy/CONTAINER_OPTIONS",
  TAXONOMY_CONTAINER_MATERIALS: "Taxonomy/CONTAINER_MATERIALS",
  TAXONOMY_PRODUCT_CATEGORIES: "Taxonomy/PRODUCT_CATEGORIES",
  PAYMENT_WALLET: "Payment/WALLET",
  PAYMENT_TRANSACTIONS: "Payment/TRANSACTIONS",
  TRANSFER_RECIPIENTS: "TransferRecipient/LIST",
  PAYOUT_LIST: "Payout/LIST",
  PAYOUT_DETAIL: "Payout/DETAIL",
  BANKING_BANKS: "Banking/BANKS",
  BANKING_OPERATORS: "Banking/OPERATORS",
  FAQ_LIST: "Faq/LIST",
};

export default QUERY_TAGS;
